import t from"./input.element.scss.js";export{CdsInput}from"./input.element.js";export{CdsInputGroup}from"./input-group.element.js";const e=t;export{e as inputStyles};
